import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { getImgPath } from '../../store/JSTool';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import * as JSTool from '../../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';

export default function GamePosterView() {

    const settingData = useSelector(state => state.settingData);
    const [swp, setSwp] = React.useState(null);
    const dataAry = [ "overlord_img.png", "works_SFD2.png", "works_OPMW.png"];

    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    return (
        <Stack sx={{
            width: 1,
            bgcolor: 'black',
        }}>

            <Stack sx={{
                height: settingData.isMobile ? 'auto' : '400px',
                justifyContent: 'center',
                flexDirection: 'row',
                pt: 1,
                pb: settingData.isMobile && 2,
                alignItems: 'center',
            }}>

                <Box
                    onClick={leftTap}
                    component={'img'}
                    src={JSTool.getImgPath('arrow_left2.png')}
                    sx={{
                        // display: !settingData.isMobile && 'none',
                        display: 'none',
                        mr: 1,
                        height: '15px',
                        width: '15px',
                        objectFit: 'cover',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.3)',
                        }
                    }} />

                <Swiper style={{
                    width: settingData.isMobile ? '80%' : '1100px',
                    textAlign: 'center',
                    margin: 0,
                    height: '100%',
                    marginLeft: '5px',
                    marginRight: '5px',
                }}
                    loop={false}
                    slidesPerView={settingData.isMobile ? 3 : 3}
                    slideToClickedSlide={settingData.isMobile}
                    onSwiper={(swiper) => {
                        setSwp(swiper);
                    }}>

                    {dataAry.map((item, index) => {
                        return <SwiperSlide key={index}><ImageItem index={index} imgName={item} /></SwiperSlide>
                    })}

                </Swiper>

                <Box
                    onClick={rightTap}
                    component={'img'}
                    src={JSTool.getImgPath('arrow_right2.png')}
                    sx={{
                        // display: !settingData.isMobile && 'none',
                        display: 'none',
                        mr: 1,
                        height: '15px',
                        width: '15px',
                        objectFit: 'cover',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.3)',
                        }
                    }} />

            </Stack>
        </Stack>
    );
}

function ImageItem(props) {

    const settingData = useSelector(state => state.settingData);
    const [imgHeight, setImgHeight] = React.useState(100);

    React.useEffect(() => {
        setImgHeight((window.innerWidth - 120) / 3 * 1.2);
    }, []);

    function itemTap() {
        if (props.index == 0) {
            window.open('https://lon.aplus-games.com/');

        } else if (props.index == 1) {
            window.open('https://www.sfduelmobile.com');

        } else if (props.index == 2) {
            window.open('https://eu.onepunchmanworld.com');
           
        } else if (props.index == 3) {
            window.open('https://myherotsh.com/');

        }
    }

    return (
        <Box
            onClick={itemTap}
            component={'img'}
            src={getImgPath(props.imgName)}
            sx={{
                height: settingData.isMobile ? `${imgHeight}px` : 0.9,
                mx: settingData.isMobile ? 0.7 : 1,
                borderRadius: settingData.isMobile ? '4px' : '8px',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.03)',
                },

            }} />
    );
}